
define('ldsh!modules/contact/list/row', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '  \n  <td>\n   <span name="first_name"></span>\n  </td>\n  \n  <td>\n   <span name="last_name"></span>\n  </td>\n  \n  <td>\n   <span name="email"></span>\n  </td>\n  \n  <td>\n   <span name="phone1"></span>\n  </td>\n  \n  <td>\n   <span name="phone2"></span>\n  </td>\n\n  <td>\n   \t\t<a href="javascript:;" class="edit-item">Edit</a>\n  </td>\n  <td>\n   \t\t<a href="javascript:;" class="delete-item">Delete</a>\n  </td>\n';

}
return __p
};});

